import React from 'react'
import { IconX } from '@chilipiper/icons/figma-generated/src/icon'
import styled from 'styled-components'
import { Flex, Text } from '../../../core-components'
import { StartContentProvider } from '../../data'
import { IconButton } from '../../action'

export const pillDataPill = 'pill'
interface Props {
  children: React.ReactNode
  'data-id'?: string
  'data-test-id'?: string
  isDisabled?: boolean
  onRemove?: () => void
  startContent?: React.ReactNode
  textValue?: string
  isTheOnlyVisible: boolean
  isVisible: boolean
  isWrapping: boolean
  labelPrefix?: (string | { label: string; startContent?: React.ReactNode })[]
}

export const CorePill = ({
  children,
  startContent,
  isDisabled,
  onRemove,
  textValue = '',
  'data-test-id': dataTestId,
  'data-id': dataId,
  isVisible,
  isTheOnlyVisible,
  isWrapping,
  labelPrefix,
}: Props) => {
  return (
    <Flex
      data-pill={pillDataPill}
      minWidth={
        // To hide pills instead of showing ellipsis, but still show ellipsis when the pill is the only visible one or the whole area is wrapping like when expanded
        isWrapping || isTheOnlyVisible ? 0 /* to make textOverflow: ellipsis work */ : 'min-content'
      }
      data-test-id={dataTestId}
      data-id={dataId}
      pl={2}
      pr={isDisabled || !onRemove ? 2 : 1}
      h='28px'
      alignItems='center'
      borderRadius={8}
      boxShadow='border/section'
      bg='bg/button-minor-default'
      style={
        isVisible
          ? undefined
          : {
              visibility: 'hidden',
              position: 'absolute',
              top: 0,
              left: 0,
            }
      }
    >
      {labelPrefix?.map(prefix => {
        const label = typeof prefix === 'string' ? prefix : prefix.label
        const startContent = typeof prefix === 'object' ? prefix.startContent : undefined

        return (
          <React.Fragment key={label}>
            <StartContentProvider value={{}}>{startContent}</StartContentProvider>
            <Text
              ml={startContent ? 2 : 0}
              textStyle='form-value'
              overflow='hidden'
              textOverflow='ellipsis'
              whiteSpace='pre'
              lineHeight={
                8 /* Overflow hidden clips the text otherwise, use negative margin to offset it */
              }
              my={-1}
              color={isDisabled ? 'fg/disabled' : 'fg/major'}
            >
              {label} /{' '}
            </Text>
          </React.Fragment>
        )
      })}
      <StartContentProvider value={{}}>{startContent}</StartContentProvider>
      <Text
        ml={startContent ? 2 : 0}
        textStyle='form-value'
        overflow='hidden'
        textOverflow='ellipsis'
        whiteSpace='pre'
        lineHeight={
          8 /* Overflow hidden clips the text otherwise, use negative margin to offset it */
        }
        my={-1}
        color={isDisabled ? 'fg/disabled' : 'fg/major'}
      >
        {children}
      </Text>
      {!isDisabled && onRemove && (
        <StyledEnableEventsDiv>
          <IconButton
            icon={IconX}
            label={`Remove ${textValue}`}
            size={5}
            variant='ghost'
            onClick={onRemove}
            hasTooltip={false}
          />
        </StyledEnableEventsDiv>
      )}
    </Flex>
  )
}
const StyledEnableEventsDiv = styled.div`
  margin-left: ${({ theme }) => theme.space[1]};
  pointer-events: auto;
`
